import React from 'react'
import { PageContent, Heading, Text, Image } from 'components/library'
import img01 from './assets/Toren_SemiClose_2.jpg'
import './Aspect03.css'

class Aspect03 extends React.Component {

  render() {
    return (
      <div className="Chapter04-Aspect03">
        <PageContent nospacing>
          <div className="has-two-cols">
            <div className="col-01">
              <Heading h2>Gereed houden voor Assistentie</Heading>
              <Text>Het kan voorkomen dat Apron Control jou oproept je gereed te houden voor assistentie om bijvoorbeeld een baan of rijbaan vrij te maken van een vliegtuig na een noodprocedure. Indien dit gebeurt dien je meteen naar de door Apron Control aangewezen plaats te gaan. Je meldt bij Apron Control wanneer je ter plaatse bent en wacht daar op nadere instructies en/of begeleiding.</Text>
            </div>
            <div className="col-02">
              <Image src={img01} />
            </div>
          </div>
        </PageContent>
      </div>
    )
  }
}

export default Aspect03



// WEBPACK FOOTER //
// ./src/content/chapters/04/03/Aspect03.js